
let currentProduct;
let iframeSrc;
let customer = 'art-mind-shop';

const isMobile = window.innerWidth < 768;

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazingProjectAvailable === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForShopifyMeta = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (window.ShopifyAnalytics?.meta) {
            clearInterval(checkInterval);
            resolve(window.ShopifyAnalytics.meta);
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};


/* AB SECTION START */
const addToCartSelector = 'button.add-to-cart';

await waitForElement(addToCartSelector);

mazingSetAB({
    enabled: true,
    addToCartListeners: (callback) => {
        document.querySelector(addToCartSelector).addEventListener('click', () => {
            console.log('MAZING: addToCartClicked A/B');
            callback();
        });
    }
});

/* AB SECTION END */


// <---------------------- Script Start ---------------------->

const changeBySKU = async (sku) => {
    console.log('changeBySKU', sku);

    if (sku) {
        if (isMobile) {
            await mazingRefreshSKU(sku, customer);
        } else {
            iframeSrc = await mazingProjectAvailable({
                customerName: customer,
                getSKU: () => {
                    return sku;
                }
            });

            if (!iframeSrc) {
                console.log('iframeSrc not found, skipping refresh.');
                return;
            }

            const iFrameElement = document.getElementById('mazing-iframe');
            if (!iFrameElement) {
                console.log('iFrameElement not found, skipping refresh.');
                return;
            }

            iFrameElement.src = iframeSrc;

        }
    } else {
        console.warn('no matching mazing sku found', sku);
    }
}

const normalizePublicTitleToEnglish = (publicTitle) => {
    const materialMap = {
        'galerieabzug': 'gallery-print',
        'impression de galerie': 'gallery-print',
        'gallery print': 'gallery-print',
        'acrylglas': 'acrylic-glass',
        'verre acrylique': 'acrylic-glass',
        'acrylic glass': 'acrylic-glass',
        'leinwand': 'canvas',
        'toile': 'canvas',
        'canvas': 'canvas',
        'brushed aluminium': 'brushed-aluminium',
        'alu gebürstet': 'brushed-aluminium',
        'aluminium brossé': 'brushed-aluminium',
        'alu': 'brushed-aluminium'
    };

    const frameMap = {
        'ohne': 'without',
        'sans': 'without',
        'without': 'without',
        'schwarz': 'black',
        'noir': 'black',
        'black': 'black',
        'weiß': 'white',
        'weiss': 'white',
        'blanc': 'white',
        'white': 'white'
    };

    const parts = publicTitle.replace(/<\/?tc>/g, '').toLowerCase().split(/\s*\/\s*/);
    if (parts.length !== 3) {
        return null;
    }

    const rawMaterial = parts[0].trim();
    const rawSize = parts[1].trim();
    const rawFrame = parts[2].trim();

    const material = materialMap[rawMaterial] || rawMaterial.replace(/\s+/g, '-');
    const size = rawSize.replace(/\s+/g, '');
    const frame = frameMap[rawFrame] || rawFrame.replace(/\s+/g, '-');

    return `${material}-${size}-${frame}`;
};



const skuByVariant = (variantID) => {
    console.log('skuByVariant called with ID', variantID);
    for (let i = 0; i < window.ShopifyAnalytics.meta.product.variants.length; i++) {
        const variant = window.ShopifyAnalytics.meta.product.variants[i];

        if (variant.id === Number(variantID)) {
            console.log('found variant', variant);
            const cleanSku = (variant.sku.match(/^\d+/)?.[0] || variant.sku).replace("'", "");
            const englishSuffix = normalizePublicTitleToEnglish(variant.public_title);

            if (!englishSuffix) {
                console.warn('Failed to normalize public_title:', variant.public_title);
                return false;
            }

            console.log('variant name', cleanSku);
            console.log('variant name', englishSuffix);


            return `${cleanSku}-${englishSuffix}`;
        }
    }

    console.error('skuByVariant no result');
    return false;
};

const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        await waitForShopifyMeta;

        console.log('mazingProjectAvailable is now available');
        console.log(`Initializing mazing (mobile) ${isMobile}`);

        const variantInput = await waitForElement('[name="id"]');
        console.log('shopify meta found ', window.ShopifyAnalytics.meta)
        console.log('initial variant found ', variantInput.value)
        const initialSKU = skuByVariant(variantInput.value);
        console.log('initial maps to sku', initialSKU)


        variantInput.addEventListener('change', (event) => {
            const newVariantId = variantInput.value;
            console.log('Variant changed to (id) ', newVariantId);
            const sku = skuByVariant(newVariantId);
            console.log('Variant resolved to (sku) ', sku);
            changeBySKU(sku);
        });

        if (isMobile) {
            mazing(
                {
                    customerName: customer,
                    buttonConfiguration: {
                        customStyle: `
                        .mazing-button-container {
                            position: absolute !important;
                            bottom: 0 !important;
                            left: 50% !important;
                            transform: translateX(-50%) !important;
                            z-index: 20 !important;
                            margin: 0 !important;
                            width: auto !important;
                            max-width: none !important;
                            padding: 10px 0;
                        }
                        .mazing-threed-btn {
                              font-size: 14px;
                              background-color: #ffffff;
                              color: #000000;
                              border: 1px solid #FFC542;
                              box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
                              border-radius: 100px;
                              display: flex;
                              align-items: center;
                              justify-content: flex-start;
                              gap: 5px;
                              padding: 7px 10px;
                              padding-right: 16px;
                              cursor: pointer;
                              position: relative;
                              transition: all 0.3s ease-out;
                            margin-right: 0;
                            margin-top: 20px;
                            height: unset;
                        }
                        
                        .mazing-threed-btn-icon {
                            width: 20px !important;
                            margin-right: 6px !important;
                        }
                        
                        .mazing-threed-btn-text{
                            color: #000;
                            font-size: 14px;
                        }
                        `,
                        placementSelector: '.product__main-photos',
                        threedBtn: {
                            enabled: true,
                            icon: true,
                            customText: navigator.language.startsWith('en')
                                ? '3D View'
                                : '3D Ansicht'
                        },
                        arBtn: {
                            enabled: false,
                            icon: true,
                            customText: 'View in AR'
                        }
                    },
                    getSKU: () => {
                        return initialSKU;
                    }
                }
            )
        } else { // desktop
            iframeSrc = await mazingProjectAvailable({
                customerName: customer,
                getSKU: () => {
                    return initialSKU;
                }
            });

            if (!iframeSrc) {
                console.log('iframeSrc not found, skipping update.');
                return;
            }

            const style = document.createElement('style');
            style.innerHTML = `
               .mazing-3d-svg-after::before {
                  content: '';
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  background-color: rgb(255 255 255 / 67%);
                  z-index: 1;
                  pointer-events: none;
              }
              .mazing-3d-svg-after::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-image: url('https://cdn.mazing.link/assets/svg/3D.svg');
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                pointer-events: none;
                background-size: 60%; /* scale down image */
                background-size: 55%;
                z-index: 2;
                filter: brightness(0) saturate(100%) invert(7%) sepia(1%) saturate(1417%) hue-rotate(314deg) brightness(112%) contrast(89%);
                            
              }
            `;
            document.head.appendChild(style);

            // Configurable "wished index" for the new thumbnail
            const wishedIndex = 4; // For example, place it at the first position (index 0)

            // Select the element with the class 'product__main-photos'
            const mainPhotosElement = document.querySelector('.product__main-photos');

            // Define the iframe element
            let iframeElement;

            if (mainPhotosElement) {
                // Create the iframe and style it
                iframeElement = document.createElement('iframe');
                iframeElement.style.cssText = "border: 0; height: 100%; left: 0; position: absolute;  top: 0; width: 100%; background: white; display: none; padding-left: 22px;"; // max-height: 600px;
                iframeElement.src = iframeSrc;
                iframeElement.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;";
                iframeElement.allowFullscreen = true;
                iframeElement.setAttribute('allowusermedia', '');
                iframeElement.id = 'mazing-iframe';

                // Append the iframe to the main photos element
                mainPhotosElement.appendChild(iframeElement);
            } else {
                console.error('Element with class "product__main-photos" not found.');
                return;
            }

            // Select the element with the class 'product__thumbs--scroller'
            const scrollerElement = document.querySelector('.product__thumbs--scroller');

            // Create a new div element to hold your content
            const newThumbItem = document.createElement('div');
            newThumbItem.className = 'product__thumb-item';
            newThumbItem.setAttribute('data-index', 'none');
            newThumbItem.style.boxShadow = ''; // Initially no box-shadow
            newThumbItem.style.padding = '';

            // Add inner HTML content to the new div
            const imgElement = document.createElement('img');
            const firstImage = document.querySelector('.image-wrap__thumbnail').children[0].children[0];
            imgElement.src = firstImage ? firstImage.src : 'https://cdn.mazing.link/assets/svg/3D.svg';
            imgElement.alt = '3D Image';
            imgElement.width = 720;
            imgElement.height = 720;
            imgElement.loading = 'eager';
            imgElement.className = 'image-element';
            imgElement.style.sizes = '(min-width: 769px) 80px, 100vw';

            const imageWrap = document.createElement('div');
            imageWrap.className = 'image-wrap image-wrap__thumbnail mazing-3d-svg-after loaded';
            imageWrap.style.cssText = 'height: 0; padding-bottom: 100.0%;';
            imageWrap.appendChild(imgElement);


            newThumbItem.appendChild(imageWrap);

            // Add a click event listener to show the iframe when this specific thumbnail is clicked
            newThumbItem.addEventListener('click', (event) => {
                if (iframeElement) {
                    iframeElement.style.display = 'block';
                } else {
                    console.error('Iframe element is not available.');
                }

                // Remove the class 'is-active' and the box-shadow from all other thumbnails
                document.querySelectorAll('.product__thumb-item').forEach((thumbItem) => {
                    thumbItem.querySelector('img')?.style.removeProperty('box-shadow');
                });

                // Add the box-shadow to the clicked thumbnail
                newThumbItem.style.boxShadow = 'inset 0 0 0 2px var(--colorTextBody)';
                newThumbItem.style.padding = '2px';

                // Remove the class 'is-active' from all a elements with 'product__thumb' class after 100ms
                setTimeout(() => {
                    document.querySelectorAll('a.product__thumb.is-active').forEach((activeThumb) => {
                        activeThumb.classList.remove('is-active');
                    });
                }, 100);

                // Prevent hiding the iframe when this specific element is clicked
                event.stopPropagation();
            });

            // Add the new thumbnail at the wished index
            if (scrollerElement) {
                const children = scrollerElement.children;

                if (wishedIndex >= 0 && wishedIndex < children.length) {
                    // Insert the new thumbnail at the wished index
                    scrollerElement.insertBefore(newThumbItem, children[wishedIndex]);
                } else {
                    // Append the new thumbnail at the end if the wished index is out of bounds
                    scrollerElement.appendChild(newThumbItem);
                }
            } else {
                console.error('Element with class "product__thumbs--scroller" not found.');
                return;
            }

            // Add event listeners to all other elements with class 'product__thumb-item'
            document.querySelectorAll('.product__thumb-item').forEach((thumbItem) => {
                // Skip adding the listener to the newly created item
                if (thumbItem !== newThumbItem) {
                    thumbItem.addEventListener('click', () => {
                        if (iframeElement) {
                            iframeElement.style.display = 'none';
                        }
                        // Remove the box-shadow from the newThumbItem image
                        newThumbItem.style.removeProperty('box-shadow');
                        newThumbItem.style.removeProperty('padding');
                    });
                }
            });

            // Automatically trigger a click on the newThumbItem only if index = 0
            if (wishedIndex === 0) {
                setTimeout(() => {
                    newThumbItem.click();
                }, 0);
            }
        }

        console.log('Mazing script initialized.');
    } catch (error) {
        console.error('Initialization failed:', error);
    }
};


initializeScript();